
import React from 'react';
import { Building2 } from 'lucide-react';

interface FloorTitleProps {
  floorNumber: number;
}

const FloorTitle: React.FC<FloorTitleProps> = ({ floorNumber }) => {
  const getFloorName = (floor: number) => {
    switch (floor) {
      case 1: return 'Ground Floor';
      case 2: return 'First Floor';
      case 3: return 'Second Floor';
      default: return `Floor ${floor}`;
    }
  };

  return (
    <h3 className="text-lg font-semibold mb-4 flex items-center">
      <Building2 className="mr-2 h-5 w-5" />
      Floor Map - {getFloorName(floorNumber)}
    </h3>
  );
};

export default FloorTitle;
